import { Box, BoxProps } from '@mui/material';

type InlineBoxProps = Omit<BoxProps, 'display'>;

export const InlineBox = (props: InlineBoxProps) => {
  return <Box {...props} display={'inline-block'} />;
};
